import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
	CommunityEndpoint,
	CommunityFaqEndpoint,
	Url,
} from "../../Type/BaseUrl";

const CommunityService = createApi({
	reducerPath: "CommunityService",
	baseQuery: fetchBaseQuery({
		baseUrl: Url,
	}),
	endpoints: (builder) => {
		return {
			communityContent: builder.query({
				query: () => {
					return {
						url: CommunityEndpoint,
						method: "GET",
					};
				},
			}),
			communityFaqsContent: builder.query({
				query: () => {
					return {
						url: CommunityFaqEndpoint,
						method: "GET",
					};
				},
			}),
		};
	},
});
export const { useCommunityContentQuery, useCommunityFaqsContentQuery } =
	CommunityService;
export default CommunityService;
